<template>
  <progress class="mx-auto" :max="max" :value="value"></progress>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    value: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
progress {
  background: transparent;
  border: none;
  color: white;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  border: 0.125rem solid white;
  border-radius: 0.75rem;
  padding: 0;
  width: 94%;
  overflow: hidden;
}

progress::-moz-progress-bar {
  background-color: white;
  border-radius: 0.75rem;
}

progress::-webkit-progress-bar {
  background-color: transparent;
}

progress::-webkit-progress-value {
  background-color: white;
  border-radius: 0.75rem;
}

@media screen and (min-width: 768px) {
  progress {
    width: 60%;
  }
}
</style>
